export default __webpack_public_path__ + "static/emp-icn6-e51443af6ae43bd0ea1a366fdef5ef5d.png";